import React, { useState } from 'react';
import { Calendar } from 'react-big-calendar';
import pb from '../../lib/pocketbase';

const TimesheetCalendarView = ({
    filteredEntries,
    localizer,
    setEditingEntry,
    setIsFormOpen
}) => {
    const [view, setView] = useState('month');
    const [date, setDate] = useState(new Date());

    const events = filteredEntries.flatMap(entry => {
        const workerName = entry.expand?.worker?.name || entry.expand?.worker?.username || 'Inconnu';
        const chantierName = entry.expand?.chantier?.name || 'N/A';
        const baseDate = entry.date.split(' ')[0]; // YYYY-MM-DD
        
        const generatedEvents = [];

        if (entry.morning_start && entry.morning_end) {
            const start = new Date(`${baseDate}T${entry.morning_start}:00`);
            const end = new Date(`${baseDate}T${entry.morning_end}:00`);
            // Fallback to allDay if Invalid Date
            if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
                generatedEvents.push({
                    id: `${entry.id}_morning`,
                    title: `👷 ${workerName} - 🏗️ ${chantierName} (Matin)`,
                    start,
                    end,
                    resource: entry,
                    allDay: false
                });
            }
        }

        if (entry.afternoon_start && entry.afternoon_end) {
            const start = new Date(`${baseDate}T${entry.afternoon_start}:00`);
            const end = new Date(`${baseDate}T${entry.afternoon_end}:00`);
            if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
                generatedEvents.push({
                    id: `${entry.id}_afternoon`,
                    title: `👷 ${workerName} - 🏗️ ${chantierName} (Après-midi)`,
                    start,
                    end,
                    resource: entry,
                    allDay: false
                });
            }
        }

        // Si aucun horaire précis n'est renseigné (ou format invalide)
        if (generatedEvents.length === 0) {
            generatedEvents.push({
                id: entry.id,
                title: `👷 ${workerName} - 🏗️ ${chantierName} (⏳ ${entry.hours}h)`,
                start: new Date(baseDate),
                end: new Date(baseDate),
                resource: entry,
                allDay: true
            });
        }

        return generatedEvents;
    });

    // Custom event style based on status
    const eventStyleGetter = (event) => {
        const entry = event.resource;
        let backgroundColor = '#3b82f6'; // Default blue
        let className = '';

        if (entry.status === 'approved') {
            backgroundColor = '#10b981'; // Green
        } else if (entry.status === 'rejected') {
            backgroundColor = '#ef4444'; // Red
        } else if (entry.status === 'pending' || entry.status === 'pending_manager' || entry.status === 'pending_rh') {
            backgroundColor = '#f59e0b'; // Orange
            className = 'rbc-event-pending';
        }

        return {
            className,
            style: {
                backgroundColor,
                borderRadius: '8px',
                color: 'white',
                border: '0px',
                display: 'block',
                fontSize: '0.85rem',
                padding: '4px 8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }
        };
    };

    // Handle event click
    const handleSelectEvent = (event) => {
        setEditingEntry(event.resource);
        setIsFormOpen(true);
    };

    // Handle slot select (create new entry)
    const handleSelectSlot = (slotInfo) => {
        const newEntry = {
            date: slotInfo.start.toISOString().split('T')[0],
            hours: 8,
            description: '',
            worker: pb.authStore.model?.id,
            chantier: '',
            status: 'pending'
        };
        setEditingEntry(newEntry);
        setIsFormOpen(true);
    };

    return (
        <div style={{
            background: 'var(--color-surface)',
            padding: '1.5rem',
            borderRadius: 'var(--border-radius-lg)',
            height: '700px'
        }}>
            <Calendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                style={{ height: '100%' }}
                eventPropGetter={eventStyleGetter}
                onSelectEvent={handleSelectEvent}
                onSelectSlot={handleSelectSlot}
                selectable
                view={view}
                onView={setView}
                date={date}
                onNavigate={setDate}
                views={['month', 'week', 'day', 'agenda']}
                messages={{
                    next: "Suivant",
                    previous: "Précédent",
                    today: "Aujourd'hui",
                    month: "Mois",
                    week: "Semaine",
                    day: "Jour",
                    agenda: "Agenda",
                    date: "Date",
                    time: "Heure",
                    event: "Événement",
                    noEventsInRange: "Aucune entrée dans cette période",
                    showMore: (total) => `+ ${total} de plus`
                }}
            />
        </div>
    );
};

export default TimesheetCalendarView;
